import type { IOnboardingStepText } from '../../types/IOnboardingStepText'

export const appealsTexts: Record<string, IOnboardingStepText> = {
  'appeals.intro': {
    title: 'Обращения граждан',
    text: 'Жалобы, отзывы и пожелания пациентов и посетителей — из личного кабинета пациента, по горячей линии, через приёмную и другие каналы. Покажем, как с ними работать.',
  },
  'appeals.create': {
    title: 'Новое обращение',
    text: 'Зарегистрируйте обращение, которое поступило не через личный кабинет: по телефону, письмом или на приёме.',
  },
  'appeals.qr': {
    title: 'QR-код обращений',
    text: 'QR-код и ссылка на публичную форму: по ней пациент сам оставит отзыв, жалобу или пожелание. Код можно скачать или распечатать.',
  },
  'appeals.settings': {
    title: 'Настройки',
    text: 'Справочник каналов поступления обращений. Доступен администраторам.',
  },
  'appeals.settings.channels': {
    title: 'Каналы поступления',
    text: 'Откуда приходят обращения. Системные каналы заданы порталом и не редактируются, пользовательские можно изменить или удалить.',
  },
  'appeals.settings.addChannel': {
    title: 'Новый канал',
    text: 'Добавьте свой канал — он появится в списке при регистрации обращения.',
  },
  'appeals.navSettings': {
    title: 'Настройки в боковом меню',
    text: 'Те же настройки открываются с любой страницы: наведите на пункт «Обращения граждан» в боковом меню — появится шестерёнка.',
  },
  'appeals.search': {
    title: 'Поиск',
    text: 'Введите слово и нажмите Enter — найдутся обращения с ним.',
  },
  'appeals.filters': {
    title: 'Фильтры колонок',
    text: 'Значок воронки в заголовке отбирает обращения по номеру, дате, каналу, теме и статусу.',
  },
  'appeals.hideAnswered': {
    title: 'Скрыть отвеченные',
    text: 'Оставляет в списке только новые обращения, на которые ещё не ответили. «Сбросить фильтры» переключатель не выключает.',
  },
  'appeals.resetFilters': {
    title: 'Сбросить фильтры',
    text: 'Возвращает полный список обращений.',
  },
  'appeals.demoRow': {
    title: 'Карточка обращения',
    text: 'Клик по строке открывает обращение.',
  },
  'appeals.form.channelTopic': {
    title: 'Канал и тема',
    text: 'Откуда пришло обращение и что это: жалоба, отзыв или пожелание.',
  },
  'appeals.form.rating': {
    title: 'Оценка заявителя',
    text: 'Для отзыва заявитель ставит оценку от 1 до 5.',
  },
  'appeals.form.applicant': {
    title: 'Заявитель',
    text: 'ФИО и контакты. На указанный email уходит официальный ответ. У обращений из личного кабинета пациента эти поля не редактируются.',
  },
  'appeals.form.target': {
    title: 'Кому адресовано',
    text: 'Отделение или сотрудник, к которому относится обращение. Поле необязательное.',
  },
  'appeals.form.text': {
    title: 'Содержание обращения',
    text: 'Что написал заявитель. Прикреплённые к обращению файлы показаны под текстом.',
  },
  'appeals.form.reply': {
    title: 'Ответ заявителю',
    text: 'Координатор обращения пишет здесь тему и текст ответа и отправляет его на email заявителя. После отправки здесь виден текст ответа, а обращение получает статус «Отвечено».',
  },
  'appeals.form.tasksEar': {
    title: 'Задача координатора',
    text: 'Координатор разбирает обращение и готовит ответ. Назначают его здесь, в панели задачи.',
  },
  'appeals.form.assignCoordinator': {
    title: 'Назначить координатора',
    text: 'Пока координатора нет, обращение никто не разбирает. Выберите сотрудника или назначьте себя.',
  },
  'appeals.form.ears': {
    title: 'Отчёты и ссылка',
    text: 'Сформировать отчёт по обращению или скопировать ссылку, чтобы отправить коллеге.',
  },
}
